var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.GetLink(),"target":_vm.GetTarget()}},[_c('ToolButton',{attrs:{"Editor":_vm.Editor,"KnownIcon":"ExternalLink","Size":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }